export enum AppPermission {
  CAMPAIGN_READ = "campaign:read",
  CAMPAIGN_PARTICIPATE = "campaign:participate",
  CAMPAIGN_WRITE = "campaign:write",
  ORGANIZATION_MANAGE = "organization:manage",
  BILLING_READ = "billing:read",
  BILLING_WRITE = "billing:write",
  ROLE_READ = "role:read",
  ROLE_WRITE = "role:write",
  INVITE_READ = "invite:read",
  INVITE_WRITE_PARTICIPANT = "invite:write:participant",
  INVITE_WRITE = "invite:write",
  ORGANIZATION_READ = "organization:read",
  WORKSPACE_READ = "workspace:read",
  WORKSPACE_WRITE = "workspace:write",
  PARTICIPATION_WRITE = "participation:write",
  MEMBER_READ = "member:read",
  MEMBER_WRITE = "member:write",
}

export interface AppRole {
  id: string,
  rank: number,
  name: string,
  role_backward_compatibility_id?: number
  permissions: AppPermission[],
}

export enum DefaultAppRole {
  OWNER = 'Owner',
  MANAGER = 'Manager',
  ADMINISTRATOR = 'Administrator',
  CONSULTANT = 'Consultant',
  PARTICIPANT = 'Participant',
}

export const OWNER_RANK = 0;
export const MANAGER_RANK = 10;
export const ADMINISTRATOR_RANK = 20;
export const CONSULTANT_RANK = 30;
export const PARTICIPANT_RANK = 40;

export enum MemberRole {
  OWNER = 0,
  ADMINISTRATOR = 1,
  USER = 2,
  PARTCIPANT = 3,
  CONSULTANT = 4,
}

const ownerPermissions = [
  AppPermission.BILLING_READ,
  AppPermission.BILLING_WRITE,
  AppPermission.CAMPAIGN_PARTICIPATE,
  AppPermission.CAMPAIGN_READ,
  AppPermission.CAMPAIGN_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_WRITE,
  AppPermission.INVITE_READ,
  AppPermission.ORGANIZATION_MANAGE,
  AppPermission.ROLE_READ,
  AppPermission.ROLE_WRITE,
];

const consultantPermissions = [
  AppPermission.CAMPAIGN_READ,
  AppPermission.PARTICIPATION_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_READ,
  AppPermission.ORGANIZATION_READ,
  AppPermission.BILLING_READ,,
];

const adminPermissions = [
  AppPermission.ORGANIZATION_READ,
  AppPermission.WORKSPACE_READ,
  AppPermission.CAMPAIGN_WRITE,
  AppPermission.CAMPAIGN_READ,
  AppPermission.PARTICIPATION_WRITE,
  AppPermission.ROLE_READ,
  AppPermission.MEMBER_WRITE,
  AppPermission.MEMBER_READ,
  AppPermission.INVITE_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_READ,
  AppPermission.BILLING_READ,
];

export const PredefinedRoles = {
  [DefaultAppRole.OWNER]: ownerPermissions,           // OWNER
  [DefaultAppRole.MANAGER]: ownerPermissions,         // MANAGER
  [DefaultAppRole.ADMINISTRATOR]: adminPermissions,   // ADMIN
  [DefaultAppRole.CONSULTANT]: consultantPermissions, // CONSULTANT
}